import { FetchClient } from "@/core/client/fetch_client"
import { getService } from "hooks/useStartup"
import { ResponseModel } from "@/core/generated/api/models/response_model"
import { ResponseSerializer } from "@/core/generated/api/response_serializer"
import { useEffect, useState } from "react"
import { StatusCode } from "@/core/generated/api/enums/status_code"
import { UserValidName } from "../models/userValidName"

type validateUserProps = {
  userId: string
}

export const useValidateUser = (props: validateUserProps) => {
  const [signedUp, setSignedUp] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [code, setCode] = useState<number | null>(null)
  const [message, setMessage] = useState<string>("")

  const getValidUser = async (id: string) => {
    if (!id) return
    setLoading(true)
    let response: ResponseModel | null = null

    try {
      const client: FetchClient = getService(FetchClient)
      response = await client.getAsync(`/user/${id}/validate-name`)

      if (response !== null) {
        const model: UserValidName | null =
          ResponseSerializer.deserialize<UserValidName>(response)
        if (model !== null) {
          setSignedUp(model.value)

          setCode(response.code)
        }
      } else {
        setCode(StatusCode.BadRequest)
      }
    } catch (err) {
      console.error(err)
      setCode(StatusCode.BadRequest)
    } finally {
      setMessage(response?.message)
      setLoading(false)
    }

    return response
  }

  useEffect(() => {
    getValidUser(props.userId)
  }, [props.userId])

  return {
    signedUp,
    loading,
    code,
    message,
  }
}
